import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import NewButton from '../NewButton';
import './ChannelGroup.css';

const ChannelGroup = ({
  groupTitle,
  tooltip,
  onGroupTitleClick,
  createChannel,
  showNewChannelButton,
  ...props
}) => {
  return (
    <div className='channel-group-list-container'>
      <div className='flex-rows' style={{ alignItems: 'center', padding: '0 12px' }}>
        <Typography onClick={onGroupTitleClick} style={{ color: '#AB9BA9', fontWeight: 600, flex: 1, cursor: 'pointer' }}>{groupTitle}</Typography>
        { showNewChannelButton && <NewButton onClick={createChannel} tooltip={tooltip} /> }
      </div>
      <ul className='channel-group-list'>
        { props.children }
      </ul>
    </div>
  );
};

ChannelGroup.propTypes = {
  groupTitle: PropTypes.string,
  tooltip: PropTypes.string,
  onGroupTitleClick: PropTypes.func,
  createChannel: PropTypes.func,
  showNewChannelButton: PropTypes.bool
};

ChannelGroup.defaultProps = {
  showNewChannelButton: true
};

// props.children will be your list of channels

export default ChannelGroup;
